let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j5F5K")).then(() => parcelRequire('3QoEw'));